export default {
  'camp67-navigation.the-camp': '营地',
  'camp67-navigation.camp67': 'camp67',
  'camp67-navigation.camp67.who-are-we': '我们是谁？',
  'camp67-navigation.camp67.camp67-&-kumbh': 'camp67 & Kumbh',
  'camp67-navigation.camp67.camp67-&-the-land': 'camp67 & 大地',
  'camp67-navigation.kumbh-2025': '玛格梅拉 2026',
  'camp67-navigation.kumbh-2025.significance-of-kumbh': 'Kumbh 的重要性',
  'camp67-navigation.kumbh-2025.paush-purnima': 'Pausha Purnima（1月3日）',
  'camp67-navigation.kumbh-2025.makar-sankranti': 'Makar Sankranti (1月14日)',
  'camp67-navigation.kumbh-2025.mauni-amavasya': 'Mauni Amavasya（1月18日）',
  'camp67-navigation.kumbh-2025.basant-panchami': 'Basant Panchami（1月23日）',
  'camp67-navigation.kumbh-2025.maghi-purnima': 'Maghi Purnima（2月1日）',
  'camp67-navigation.kumbh-2025.maha-shivratri': 'Maha Shivratri（2月15日）',
  'camp67-navigation.packages': '套餐',
  'camp67-navigation.packages.reserve-a-room': '预订房间',
  'camp67-navigation.packages.twin-room': '双床小屋',
  'camp67-navigation.packages.family-room': '家庭小屋',
  'camp67-navigation.packages.family-room-plus': '家庭小屋 Plus',
  'camp67-navigation.packages.dormitory-single': '宿舍（单人）',
  'camp67-navigation.packages.dormitory-bunk': '宿舍（双层床）',
  'camp67-navigation.contact-us': '联系我们',
  'camp67-banner.inquire-now': '表达兴趣',
  'camp67-banner.book-now': '立即预订',
  'camp67-header.tagline': '和平的神圣聚会。',
  'camp67-header.typewriter.prefix': '入住最',
  'camp67-header.typewriter.serene': '宁静的',
  'camp67-header.typewriter.peaceful': '和平的',
  'camp67-header.typewriter.safe': '安全的',
  'camp67-header.typewriter.secure': '有保障的',
  'camp67-header.typewriter.hygienic': '卫生的',
  'camp67-header.typewriter.affordable': '实惠的',
  'camp67-header.typewriter.suffix.start': '营地',
  'camp67-header.typewriter.suffix.end': '玛格梅拉 2026。',
  'camp67-header.reserve-your-spot.prefix.desktop': '立即预订',
  'camp67-header.reserve-your-spot.prefix.mobile': '立即预订',
  'camp67-header.reserve-your-spot.secure-checkout': '安全结账：',
  'camp67-link.sukrit-wellness-tours': 'Sukrit Wellness Tours →',
  'camp67-link.kumbh-sukrit-camp': 'Kumbh Sukrit Camp →',
  'camp67-link.see-more-on': '查看更多于',
  'camp67-link.learn-more': '了解更多',
  'camp67-link.terms-of-service': '服务条款',
  'camp67-link.privacy-policy': '隐私政策',
  'camp67-link.payment-policy': '支付政策',
  'camp67-link.cancellation-policy': '取消政策',
  'camp67.submit': '提交',
  'camp67.reset': '重置',
  'camp67.continue': '付款 →',
  'camp67.go-back': '返回',
  'camp67.ssl': '通过 SSL 和浏览器安全策略保护。',
  'camp67-one-of-a-kind.premium.prefix': '来自的高端宿舍和私人小屋提供商',
  'camp67-one-of-a-kind.team-behind': '来自团队',
  'camp67-one-of-a-kind.quality.hygienic.title': '卫生',
  'camp67-one-of-a-kind.quality.hygienic.image-alt':
    '全球著名的Sanskriti歌手，来自法国的特邀嘉宾Gabriella Burnel坐在Gaushala的场地上。',
  'camp67-one-of-a-kind.quality.hygienic.text': '保持国际高标准，为了您的舒适。',
  'camp67-one-of-a-kind.quality.safe-and-secure.title': '安全可靠',
  'camp67-one-of-a-kind.quality.safe-and-secure.image-alt':
    'Kumbh Sukrit 营地2019的高而安全的门。',
  'camp67-one-of-a-kind.quality.safe-and-secure.text': '各地名人和公众人物的首选住宿。',
  'camp67-one-of-a-kind.quality.peaceful.title': '宁静',
  'camp67-one-of-a-kind.quality.peaceful.image-alt':
    'Kumbh Sukrit 营地安静的森林般的围栏，高大的树木、干净的路径和优美的环境。',
  'camp67-one-of-a-kind.quality.peaceful.text':
    '坐落在 <i>Sanskriti Vann</i>，仙人们在此冥想。',
  'camp67-one-of-a-kind.graphic.2013': '500+ 参会者，10+ 国家',
  'camp67-one-of-a-kind.graphic.2019': '10,000 名参加者，26 个国家',
  'camp67-one-of-a-kind.graphic.2025.description': '目前已预订',
  'camp67-one-of-a-kind.graphic.2025.book-now': '立即预订！',
  'camp67-one-of-a-kind.calendar.paush-purnima.date': '2026年1月3日',
  'camp67-one-of-a-kind.calendar.paush-purnima.title': 'Pausha Purnima',
  'camp67-one-of-a-kind.calendar.paush-purnima.description':
    '首个重要的沐浴日，标志着 Magh Mela 的开始。',
  'camp67-one-of-a-kind.calendar.makar-sankranti.date': '2026年1月14日',
  'camp67-one-of-a-kind.calendar.makar-sankranti.title': 'Makar Sankranti',
  'camp67-one-of-a-kind.calendar.makar-sankranti.description':
    '最为吉祥的日子之一；太阳进入摩羯座。',
  'camp67-one-of-a-kind.calendar.mauni-amavasya.date': '2026年1月18日',
  'camp67-one-of-a-kind.calendar.mauni-amavasya.title': 'Mauni Amavasya',
  'camp67-one-of-a-kind.calendar.mauni-amavasya.description':
    '“沐浴之王”；信众守持静默并进行圣浴。',
  'camp67-one-of-a-kind.calendar.basant-panchami.date': '2026年1月23日',
  'camp67-one-of-a-kind.calendar.basant-panchami.title': 'Basant Panchami',
  'camp67-one-of-a-kind.calendar.basant-panchami.description':
    '春天的到来；敬奉女神萨拉斯瓦蒂。',
  'camp67-one-of-a-kind.calendar.maghi-purnima.date': '2026年2月1日',
  'camp67-one-of-a-kind.calendar.maghi-purnima.title': 'Maghi Purnima',
  'camp67-one-of-a-kind.calendar.maghi-purnima.description':
    '对完成苦修的 Kalpwasi 而言，这是一个重要的圣浴日。',
  'camp67-one-of-a-kind.calendar.maha-shivratri.date': '2026年2月15日',
  'camp67-one-of-a-kind.calendar.maha-shivratri.title': 'Maha Shivratri',
  'camp67-one-of-a-kind.calendar.maha-shivratri.description':
    'Magh Mela 的收官之日；敬奉湿婆神。',
  'camp67-we-love-kumbh.decade-old': '一个有十年历史的故事',
  'camp67-we-love-kumbh.we-know-and': '我们知道并且',
  'camp67-we-love-kumbh.love': '爱',
  'camp67-we-love-kumbh.rto-kumbh-hosts':
    '作为一个注册旅游运营商，与印度奇迹一起，我们已经举办 Kumbh 超过10年。',
  'camp67-we-love-kumbh.moments-kumbh-2019': '2019年Kumbh的时刻',
  'camp67-we-love-kumbh.hear-from-visitors': '听听我们的国际游客怎么说',
  'camp67-we-love-kumbh.richard-testimonial.location': '纽约，美国',
  'camp67-we-love-kumbh.richard-testimonial.image-alt':
    '2019年，来自美国纽约的Richard Singh在我们的营地。',
  'camp67-we-love-kumbh.richard-testimonial.quote':
    '营地非常棒。工作人员非常惊人且通融。在这里每个人都成了我的朋友。',
  'camp67-we-love-kumbh.rajesh-testimonial.location': '沃尔沃采购高级副总裁',
  'camp67-we-love-kumbh.rajesh-testimonial.image-alt':
    '沃尔沃采购高级副总裁Rajesh Mittal在2019年的我们的营地。',
  'camp67-we-love-kumbh.rajesh-testimonial.quote':
    '如此平静和神圣的体验。我们非常享受我们的住宿，我们还会回来。',
  'camp67-we-love-kumbh.gabriella-testimonial.location': '梵文学者, @gaieasanskrit',
  'camp67-we-love-kumbh.gabriella-testimonial.image-alt':
    '梵文学者Gabriella Burnel在2019年的我们的营地。',
  'camp67-we-love-kumbh.gabriella-testimonial.quote':
    '在这个地方我学到一件事：不需要希望什么。这将以它自然的方式发生。',
  'camp67-we-love-kumbh.pawars-testimonial.location': '微软和Edukinect',
  'camp67-we-love-kumbh.pawars-testimonial.image-alt':
    'Amit和Swapna Pawar来自微软和Edukinect在2019年的我们的营地。',
  'camp67-we-love-kumbh.pawars-testimonial.quote':
    '极其美丽，非常舒适。从每个人那里得到的服务都非常好。',
  'camp67-our-location.ganges-banks': '在恒河河岸',
  'camp67-our-location.lay-tents':
    '放置六十七个佛堂 <br className="hidden sm:block" /> 坚强且华丽',
  'camp67-our-location.ganges-banks-location':
    '位于恒河河岸，您不会错过任何Kumbh活动，同时在远离喧嚣的地方拥有自己的私人围栏。',
  'camp67-accommodation.twin-room.title': '双床小屋',
  'camp67-accommodation.twin-room.image-alt': '一间设有两张单人床和舒适座位安排的房间。',
  'camp67-accommodation.twin-room.subtitle': '供两人。',
  'camp67-accommodation.twin-room.description':
    '温馨的小屋，配有两张单人床。非常适合情侣、朋友或兄弟姐妹。',
  'camp67-accommodation.twin-room.guests': '2位客人',
  'camp67-accommodation.family-room.title': '家庭小屋',
  'camp67-accommodation.family-room.image-alt':
    '一间宽敞的双人房，配有一张与母床连着的双层床，以及一张单人床。',
  'camp67-accommodation.family-room.subtitle': '供四口之家。',
  'camp67-accommodation.family-room.description':
    '宽敞的小屋，配有一张大床（连着一张双层床）以及一张单人床。非常适合小家庭。',
  'camp67-accommodation.family-room.guests': '4位客人',
  'camp67-accommodation.family-room-plus.title': '家庭小屋 Plus',
  'camp67-accommodation.family-room-plus.image-alt':
    '一间宽敞的双人房，配有一张与母床连着的双层床，以及独立的双层床。',
  'camp67-accommodation.family-room-plus.subtitle': '供六口之家。',
  'camp67-accommodation.family-room-plus.description':
    '一间大套房，有2张连有双层床的皇后床。最适合大家庭。',
  'camp67-accommodation.family-room-plus.guests': '6位客人',
  'camp67-accommodation.dorm-single.title': '单人宿舍',
  'camp67-accommodation.dorm-single.image-alt':
    '经济实惠的单人床宿舍房间。实际设施中没有墙壁。',
  'camp67-accommodation.dorm-single.subtitle': '供一人，宿舍风格。',
  'camp67-accommodation.dorm-single.description':
    '一间有8张单人床的大宿舍中的一张单人床的公共套房。',
  'camp67-accommodation.dorm-single.guests': '8 位客人',
  'camp67-accommodation.dorm-bunk.title': '双层床宿舍',
  'camp67-accommodation.dorm-bunk.image-alt':
    '经济实惠的双层床宿舍房间。实际设施中没有墙壁。',
  'camp67-accommodation.dorm-bunk.subtitle': '首先，宿舍（上下铺）风格。',
  'camp67-accommodation.dorm-bunk.description':
    '一间有8张双层床的大宿舍中的一张双层床的公共套房。',
  'camp67-accommodation.dorm-bunk.guests': '8 位客人',
  'camp67-accommodation.price-per-guest': '／晚',
  'camp67-accommodation.price-meals-included': '含餐',
  'camp67-accommodation.price-bathing-dates': '在沐浴日期',
  'camp67-accommodation.view-next': '查看下一个 >',
  'camp67-accommodation.choose-accommodation': '选择住宿',
  'camp67-accommodation.call-to-learn-more':
    '拨打或发送WhatsApp至 +91 84858 35675 以了解更多信息。',
  'camp67-accommodation-and-amenities.amenities-included': '包含所有设施',
  'camp67-accommodation-and-amenities.come-to-home':
    '来到你的<home-highlight>家</home-highlight><br />在远方也如在家',
  'camp67-accommodation-and-amenities.choose-from-packages':
    '选择我们的住宿套餐，适合个人、夫妻、家庭和团体（小型和大型）。',
  'camp67-accommodation-and-amenities.luxurious-title': '豪华帐篷',
  'camp67-accommodation-and-amenities.luxurious-detail':
    '豪华帐篷小屋可容纳2、3、4或6人，或带单人床和双层床的帐篷宿舍。',
  'camp67-accommodation-and-amenities.all-in-one-city-title': '一体化帐篷城',
  'camp67-accommodation-and-amenities.all-in-one-city-detail':
    '每个私人小屋或宿舍的公共区域、训练有素的员工提供的24/7服务，以及一个中央咖啡馆。',
  'camp67-accommodation-and-amenities.heater-services-title': '加热服务',
  'camp67-accommodation-and-amenities.heater-services-detail':
    '提供加热解决方案，无论外界温度如何，确保温暖舒适的环境。',
  'camp67-accommodation-and-amenities.cafe-central-title': '24/7 中央咖啡馆',
  'camp67-accommodation-and-amenities.cafe-central-detail':
    '全天候咖啡馆，提供各种咖啡、茶和食品选择。',
  'camp67-accommodation-and-amenities.daily-housekeeping-title': '日常保洁',
  'camp67-accommodation-and-amenities.daily-housekeeping-detail':
    '每天提供清洁服务，确保您的空间一尘不染、温馨惬意，特别注重细节。',
  'camp67-accommodation-and-amenities.bottled-water-title': '瓶装水',
  'camp67-accommodation-and-amenities.bottled-water-detail':
    '赠送优质瓶装水，每天补充，确保您的水分和舒适。',
  'camp67-accommodation-and-amenities.natural-gardens-title': '灵性体验',
  'camp67-accommodation-and-amenities.natural-gardens-detail':
    '营地提供 Yagyashala、冥想、瑜伽以及其他灵性体验。',
  'camp67-accommodation-and-amenities.ayurvedic-products-title': '阿育吠陀产品',
  'camp67-accommodation-and-amenities.ayurvedic-products-detail':
    '可使用一系列独家天然阿育吠陀护肤产品，助你焕活身心、恢复活力。',
  'camp67-accommodation-and-amenities.minutes-from-ganges-title': '距离恒河几分钟',
  'camp67-accommodation-and-amenities.minutes-from-ganges-detail':
    '战略位置，步行5分钟即可到达神圣的恒河，方便接近其宁静的水域和周边地区。',
  'camp67-accommodation-and-amenities.yoga-and-meditation-title': '瑜伽和冥想课程',
  'camp67-accommodation-and-amenities.yoga-and-meditation-detail':
    '参与古印度习练，这些活动包含在我们的住宿套餐价格中。',
  'camp67-tent-amenity.comfortable-living': '舒适生活',
  'camp67-tent-amenity.comfortable-living.single-beds': '选择一套单人床或一张双层床',
  'camp67-tent-amenity.comfortable-living.single-bed': '单人床',
  'camp67-tent-amenity.comfortable-living.bunk-bed': '双层床',
  'camp67-tent-amenity.comfortable-living.queen-bed': '大床和双层床，另有单人床',
  'camp67-tent-amenity.comfortable-living.two-queen-beds': '两个大床和双层床',
  'camp67-tent-amenity.comfortable-living.quilt-blanket-pillows': '毯子和枕头',
  'camp67-tent-amenity.comfortable-living.side-table-per-bed': '每张床的床头柜',
  'camp67-tent-amenity.comfortable-living.centre-table': '中央桌',
  'camp67-tent-amenity.comfortable-living.sofa-chairs': '2个沙发椅',
  'camp67-tent-amenity.comfortable-living.side-table-kettle':
    '带热水壶、一次性杯子的床头柜',
  'camp67-tent-amenity.comfortable-living.table-lamp': '台灯',
  'camp67-tent-amenity.toiletries': '洗漱用品',
  'camp67-tent-amenity.toiletries.shared-toilets-twin':
    '共享厕所和浴室（与其他7个房间共用）',
  'camp67-tent-amenity.toiletries.shared-toilets-dorm': '共享厕所和浴室（宿舍共用）',
  'camp67-tent-amenity.toiletries.shared-toilets-family':
    '共享厕所和浴室（与其他3个家庭共用）',
  'camp67-tent-amenity.toiletries.bath-towel': '薄棉毛巾 (Gamcha)',
  'camp67-tent-amenity.toiletries.sukrit-soaps-lotion':
    '免费提供Sukrit Ayurveda肥皂和乳液',
  'camp67-tent-amenity.toiletries.small-dustbin': '小垃圾桶',
  'camp67-tent-amenity.power-storage': '电源和存储',
  'camp67-tent-amenity.power-storage.electric-power-point': '电源插座',
  'camp67-tent-amenity.power-storage.electric-power-point-2x':
    '2个带有多个插槽的电源插座',
  'camp67-tent-amenity.power-storage.electric-power-point-4-sets':
    '4组带有多个插槽的电源插座（每个部分2组）',
  'camp67-tent-amenity.power-storage.luggage-storage-racks': '行李存放架',
  'camp67-tent-amenity.food-beverage': '食品和饮料',
  'camp67-tent-amenity.food-beverage.drinking-water': '饮用水瓶（每人1 x 500ml）',
  'camp67-tent-amenity.food-beverage.tea-biscuits': '可购买茶包和饼干',
  'camp67-tent-amenity.food-beverage.lemongrass-tea-biscuits': 'Sukrit柠檬草茶和饼干',
  'camp67-tent-amenity.food-beverage.complimentary-meals':
    '<strong>免费</strong> 早餐、午餐和晚餐（在餐厅提供自助餐）',
  'camp67-tent-amenity.complimentary': '免费',
  'camp67-tent-amenity.complimentary.souvenir': '纪念品 - 每人一个带有camp67标志的棒球帽',
  'camp67-faq.private-suites': '你们提供私人套房吗？',
  'camp67-faq.private-suites.answer':
    '<p>是的！</p><paragraph>我们在camp67提供3种私人小屋选择 - <twin-room-link>双床小屋</twin-room-link>, <family-room-link>家庭小屋</family-room-link> 或 <family-room-plus-link>家庭小屋加</family-room-plus-link> 选项（2，4，6 人）。我们的其他2个选项是较大帐篷宿舍的一部分，可提供单人床或双层床。</paragraph><paragraph>如果您有任何疑问，请通过右侧的咨询表单联系我们，包括您是否希望入住一个更加隐秘、私人的空间。对此，我们可以将您连接到我们的其他产品 <kumbh-sukrit-link>Kumbh Sukrit Camp</kumbh-sukrit-link>。</paragraph>',
  'camp67-faq.camp-start': '你们的营地何时开始？',
  'camp67-faq.camp-start.answer':
    '<p>我们将从1月11日开始接受预订。如果计划早于此日期开始，我们将告知您。<camp-start-link>在下面订阅</camp-start-link>，以获取此类更新。</p>',
  'camp67-faq.international-travel': '你们适合国际旅行者吗？',
  'camp67-faq.tours-packages': '你们提供任何旅游和套餐吗？',
  'camp67-faq.kumbh-sukrit': '你们与Kumbh Sukrit Camp是什么关系？',
  'camp67-faq.all-day-facilities': '你们有全天设施吗？',
  'camp67-faq.international-travel.answer':
    '<p>是的！如在<international-travel-link>上面</international-travel-link>提到的，我们在2019年Kumbh的一版中接待了来自26个国家的旅客。无论是在航班预订、到达印度后的交通安排、还是在这里可以享受的本地游览，我们都能满足您的需求。</p> <paragraph>如果您有 兴趣与我们交谈，欢迎通过电子邮件、WhatsApp或下面的实时聊天联系。右侧的询问表单也是一个很好的起点！</paragraph>',
  'camp67-faq.tours-packages.answer':
    '我们有！请通过右侧的询问表单，或我们的提供的电子邮件、电话号码、WhatsApp或实时聊天联系 我们。我们愿意了解您的需求，以便我们最有效地满足您。',
  'camp67-faq.kumbh-sukrit.answer':
    '<p><kumbh-sukrit-link>Kumbh Sukrit Camp</kumbh-sukrit-link> 和 camp67 均属于 <swt-link>Sukrit Wellness Tours</swt-link> 旗下一部分。简而言之：我们是一个跨越三个项目的联合团队，旨在提供变革性的健康体验。我们在印度运营已有10多年，并为所有人提供各种各样的住宿和旅游选择。</p> <paragraph>虽然 camp67 是我们团队的新产品，但它携带了我们以前版本的 <kumbh-sukrit-link>Kumbh Sukrit Camp</kumbh-sukrit-link> 的很多特点。如果你之前住过我们的营地，我们确信你会喜欢这新旧结合的感觉。</paragraph>',
  'camp67-faq.all-day-facilities.answer':
    '是的！我们举办Kumbh营地的地点即使在Kumbh之外也是我们拥有和管理的。因此，即使您今天来访，它们也有全天设施。如果您感兴趣具体的设施，请告知我们。',
  'camp67-get-in-touch.success-thankyou': '谢谢您。',
  'camp67-get-in-touch.success-message': '我们已收到你的请求，会尽快与你联系！',
  'camp67-get-in-touch': '联系我们',
  'camp67-get-in-touch.12-hours':
    '对2026年Magh Mela感兴趣？我们随时为您提供帮助！立即咨询，我们将在12小时内回复您。',
  'camp67-get-in-touch.placeholder-name': '输入您的名字...',
  'camp67-get-in-touch.error-name': '请输入您的名字',
  'camp67-get-in-touch.placeholder-phone': '输入您的电话...',
  'camp67-get-in-touch.error-phone': '请输入有效的电话号码',
  'camp67-get-in-touch.placeholder-email': '输入您的电子邮件...',
  'camp67-get-in-touch.error-email': '请输入有效的电子邮件',
  'camp67-get-in-touch.placeholder-inquiry': '输入您的询问...',
  'camp67-get-in-touch.error-inquiry': '请输入询问内容',
  'camp67-experience-kumbh.the-kumbh': 'Magh Mela',
  'camp67-experience-kumbh.engage-unique-experience':
    '参与 Magh Mela 中最<unique-highlight>独特</unique-highlight><br />的体验。',
  'camp67-experience-kumbh.sadhus':
    '从与Nāga Sadhus的互动到参与最大的人类和文化聚会，体验Magh Mela。',
  'camp67-experience-kumbh.sound.mobile': 'Magh Mela的声音',
  'camp67-experience-kumbh.play-sound': '聆听Magh Mela的声音',
  'camp67-experience-kumbh.pause-sound': '暂停Magh Mela的声音',
  'camp67-experience-kumbh.naga-sadhu.image-alt': '一名Nāga Sadhu在Kumbh Mela。',
  'camp67-experience-kumbh.naga-sadhu-orange.image-alt':
    '一名Nāga Sadhu在Kumbh Mela，身穿橙色服装。',
  'camp67-experience-kumbh.naga-sadhu-beard.image-alt':
    '一名Nāga Sadhu在Kumbh Mela，有着独特长胡子。',
  'camp67-experience-kumbh.canoe.image-alt': '一名男子在恒河中划独木舟。',
  'camp67-join-now.book-now': '~ 现在预订 ~',
  'camp67-join-now.interested-in-kumbh':
    '对2026年Magh Mela感兴趣？<join-us-text>加入我们</join-us-text>',
  'camp67-join-now.book-now-lowest-price':
    '<strong>立即预订房间 →</strong><br />起始价格',
  'camp67-join-now.chat-with-us': '<strong>与我们聊天 →</strong><br />随时问我们任何问题',
  'camp67-footer.stay-informed':
    '<strong>保持知晓。</strong> 我们会通知您任何折扣和促销活动。无垃圾邮件！',
  'camp67-footer.email.placeholder-subtle': '您的电子邮件...',
  'camp67-footer.email.placeholder':
    '在此输入您的电子邮件地址。例如，ilovecamp67@gmail.com...',
  'camp67-footer.subscribe-for-updates': '订阅更新',
  'camp67-footer.camp67-summary':
    '作为<swt-link>Sukrit Wellness Tours</swt-link>的一部分，camp67来自<ksc-link>Kumbh Sukrit Camp</ksc-link>背后的团队。附属于旅游部和不可思议的印度，我们已举办Kumbh超过10年。<join-us-link>2026年加入我们</join-us-link>',
  'camp67-footer.a-product-of': '由...制作',
  'camp67-footer.subscribe-success': '您已订阅！',
  'camp67-footer.subscribe-success-message':
    '感谢您订阅我们的最新更新和新闻。我们希望您和我们一样对即将到来的活动感到兴奋！',
  'camp67-footer.subscribe-opt-out': '您可以随时选择退出此订阅。',
  'camp67-content-page.read-more': '阅读更多',
  'camp67-content-page.child.reading-time': '分钟阅读时间',
  'camp67-packages-page.subtitle': '选择多种住宿选项。',
  'camp67-packages-page.hero-image-alt': '瓦拉纳西港口的日落景象，恒河上的船只。',
  'camp67-packages-page.summary': '了解我们提供的住宿并立即预订！',
  'camp67-packages-page-children.summary':
    '浏览我们在 camp67 提供的住宿选项。立即预订您的位置！',
  'camp67-tent-page.twin-room-summary':
    '<p>\n 双人房最适合夫妻、朋友和兄弟姐妹。它是一个舒适、私密的帐篷房，为您在Magh Mela场地的日常探险中，提供完美的居住体验。\n</p>\n<paragraph>我们鼓励您拿上一杯来自camp67咖啡馆的咖啡，坐下来。和对方聊聊当天的观察，并规划接下来的一天！</paragraph>',
  'camp67-tent-page.family-room-summary':
    '<p>\n家庭旅行中最愉快的部分就是共同体验事物。我们在camp67家庭小屋对此非常重视。单人床和一张带附属双层床的女王床正等待着您，还有宽敞的空间。\n</p>\n<paragraph>选择每个人的床位可能是一项练习（它总是这样，不是吗……），但我们相信在克服了这一必要障碍后，您会感到宾至如归。</paragraph>',
  'camp67-tent-page.family-room-plus-summary':
    '<p>\n如果您认为在家庭小屋选择床位很棘手，请等待进入家庭小屋 Plus……它配备了两张女王床和附属双层床，非常适合六口之家和团体，同时也有自己的套房。\n</p>\n<paragraph>与家人分享美好时光。不必担心任何事情——您的行李是安全的，您的咖啡总是温暖的并等待着您，等等…</paragraph>',
  'camp67-tent-page.dorm-single-summary':
    '<p>\n作为单独旅行者、博主或数字游牧者，想要结识其他人吗？宿舍房就是为你准备的。加入其他人热闹的旅行旅舍环境。这间房有八张床，介于‘给我一点空间’和‘我想聊天’之间，这正是单独旅行者熟悉的微妙平衡。\n</p>',
  'camp67-tent-page.dorm-bunk-summary':
    '<p>\n如果你想要更传统的单独旅行体验；在我们的更大宿舍房中抓一个上下铺吧！这些房间可以容纳十六个人，是认识能整晚给你讲鬼故事的人的绝佳场所。\n</p>\n<paragraph>如果你是和团体一起旅行，这可能是一个特别有趣的选择。如果是这样，请告诉我们，我们会为你安排好。</paragraph>',
  'camp67-tent-page.back-to-packages': '返回所有套餐',
  'camp67-tent-page.book-tent-now': '立即预订此房间！',
  'camp67-who-we-are.subtitle': 'camp67 背后的精神。',
  'camp67-who-we-are.hero-image-alt': '瓦拉纳西港口的日落景象，恒河上的船只。',
  'camp67-who-we-are.summary':
    '来自Kumbh Sukrit团队，为您带来camp67：Magh Mela 2026中最实惠、宁静和祥和的体验。',
  'camp67-who-we-are.content':
    "\n  <p>\n        用一句话来说：<strong>camp67</strong>是对Magh Mela传统的工艺、文化传统和敬意的劳动成果。\n      </p>\n      <paragraph>\n        我们是一群多元化背景的个体，来自不同的专业和个人背景，大家汇聚一堂，共同实现这场全世界数百万朝圣者每六年一次的伟大冒险。对我们来说，Magh Mela是通往改变的门户。\n      </paragraph>\n      <paragraph>\n        camp67是我们对Magh Mela营地的愿景，欢迎所有人。对我们来说，'所有人'部分至关重要，因为Kumbh的精神和基本原则是“人性”。\n      </paragraph>\n      <paragraph>\n        在camp67，你不仅会遇到那些正在自己生活冒险中的世界各地的人，还可以在我们的24小时咖啡厅与他们一起坐下，畅聊人生故事。你会遇到博主和旅行者，他们可以告诉你Prayag Raj最佳街头食品的位置。你会遇到我们团队，尽管他们穿着制服，也会与你同坐，向你讲述\n        <the-land-link>camp67土地</the-land-link>\n        的故事，并令你对此独特性感到惊奇。\n      </paragraph>\n      <paragraph>\n        为什么我们对你加入我们感到兴奋？因为我们相信你会爱上这里，并且你会想再次回来。\n      </paragraph>\n      <paragraph>\n        相信我们，\n        <camp67-kumbh-link>我们之前做过</camp67-kumbh-link>：在2019年Kumbh Mela中，以Kumbh Sukrit之名。\n      </paragraph>\n      <paragraph>\n        Kumbh Sukrit已经参与Kumbh超过一个十年。从全球25个国家接待了超过10,000名客人。我们是一个来自各个行业的专业团队，对（1）古印度的传统和（2）优质服务充满热情。\n      </paragraph>\n      <paragraph>\n        在过去的十年中，这带领我们踏上了探索Kumbh Mela非凡遗产和独特性的独特旅程。\n        2019年，我们在著名的“Sanskriti Vann”帐篷村接待了来自全球的数千名客人，那里是古代Rishis和Yogis冥想多年的地方。\n      </paragraph>\n      <paragraph>\n        借助这些经验，我们非常兴奋地推出camp67，为您带来Magh Mela的终身体验。\n      </paragraph>\n      <p>\n        要查看我们的具体位置，请参见<maps-link>谷歌地图</maps-link>。我们位于Prayagraj的Daraganj的Sangam Ghat附近！\n      </p>\n      ",
  'camp67-who-we-are-summary':
    '来自Kumbh Sukrit团队，为您带来camp67：Magh Mela 2026中最实惠、宁静和祥和的体验。',
  'camp67-and-kumbh.subtitle': '为什么我们重视Magh Mela？',
  'camp67-and-kumbh.hero-image-alt': '瓦拉纳西港口的日落景象，恒河上的船只。',
  'camp67-and-kumbh.summary':
    '为什么选择玛格梅拉？在所有节日和活动中，为什么选择玛格梅拉？嗯，好问题——这一切都在隐藏的细节中……',
  'camp67-and-kumbh.content':
    '\n    <paragraph>\n      多年前我们就爱上了玛格梅拉。在世界上，很少有活动能有如此规模和独特性；可以说在人类历史上也鲜有这样的活动。\n    </paragraph>\n    <paragraph>\n      为什么呢？嗯，还有哪里能看到超过1.4亿人聚集在同一个地方，怀着各自的希望和梦想？这确实是一个巨大的活动，但其美丽不仅在于数字，更在于你在现场所见。\n    </paragraph>\n    <paragraph>\n      首先：当你去玛格梅拉时，您会在恒河河畔遇到无数中小型会场（距离camp67仅几步之遥），这些帐篷城市是普拉亚格拉吉市在活动开始之前搭建的，还有处处的其他地点。它完全改变了你的晨间散步；你以一种印象开始你在玛格梅拉会场的游荡，而结束时你的期望将被完全改写，视角完全转变。\n    </paragraph>\n    <paragraph>\n      这在实际中是什么样子？来自印度各地的精神领袖们大批聚集于此。来自各类背景的裸体修士呈现自我和自己的故事给大众。农村家庭从村庄赶来寻求新生活的祝福。故事和体验是不计其数的。\n    </paragraph>\n    <paragraph>\n      可以肯定的是：你一定会在玛格梅拉带走属于你自己的故事。\n    </paragraph>\n  ',
  'camp67-and-the-land.subtitle': '印度的古老故事。',
  'camp67-and-the-land.hero-image-alt': '瓦拉纳西港口的日落景象，恒河上的船只。',
  'camp67-and-the-land.summary':
    'camp67 所在的土地有着不再显而易见的历史。它是世界上最独特的地方之一。',
  'camp67-and-the-land.content':
    '\n    <paragraph>\n      camp67紧邻Sanskriti Vann。字面翻译，Sanskriti Vann是‘神圣的森林’。几千年前，这里是圣人和大圣们静坐冥想的不受干扰的神圣场所。即使你不了解，这些冥想可能持续数月、数年甚至数十年。这样的独特性来自印度的圣人。camp67所在的土地也与传说中的因陀罗——印度的战争、雨水和雷电之神，诸神之王——有联系。\n    </paragraph>\n    <paragraph>\n      许多曾在此冥想的圣人坐落于Sanskriti Vann仍然存在的树下。进入这个地方时你会注意到这一点——这些树高耸在你之上，但同时提供了古老的保护，免受外界喧嚣的干扰。\n    </paragraph>\n    <paragraph>\n      想象一下：你离开忙碌、嘈杂的印度街头，左转进入一个营地。进入后，你几乎听不到外界的声音，被历史悠久的围绕所包围，被大自然的保卫所环抱。这给你一种前所未有的宁静体验。2026年玛格梅拉期间，camp67的客人将获得Sanskriti Vann的独特入场权。\n    </paragraph>\n    <paragraph>\n      最后：想想距离camp67仅仅十分钟的地方有超过一亿人，正准备踏上他们的玛格梅拉之旅。突然，土地的吸引力让你着迷，于是……你决定在玛格梅拉建立一个营地，邀请所有人加入！\n    </paragraph>\n    <paragraph>\n      大致（而真实）地来说，camp67就是这样开始的。是这片土地先来的。\n    </paragraph>\n  ',
  'camp67-the-camp.subtitle': '了解更多关于我们的信息！',
  'camp67-the-camp.hero-image-alt': '瓦拉纳西港口的日落景象，恒河上的船只。',
  'camp67-the-camp.summary':
    '了解更多关于 camp67 存在的原因，以及是什么驱使我们做我们所做的事情。',
  'significance-of-kumbh.subtitle': '库姆布的故事。',
  'significance-of-kumbh.hero-image-alt': '阿修罗（左）和天神（右）搅乳海。',
  'significance-of-kumbh.summary':
    'Kumbh 的故事既象征性又具有字面意义。从字面意义上讲：Kumbh 意味着‘壶’。它代表一个装有不朽神圣甘露的壶。',
  'significance-of-kumbh.content':
    '\n    <p>\n      我们庆祝Kumbh，标志着印度教众神（Devās）和恶魔（Rākshasas）之间的古老战斗的认知。\n    </p>\n    <paragraph>\n      故事讲的是很多年前，印度教众神和恶魔联手搅动牛奶海（Kshirasagara），以获取一种最珍贵的宝物；不朽的甘露（Amritā）。他们用Mandar山作为搅动点，用蛇Vasuki作为绳索。毗湿奴大神以乌龟的形态支撑着这座山。\n    </paragraph>\n    <paragraph>\n      当他们搅动大海时，神性显现出来：财富、命运、繁荣、权力、美丽和繁荣的印度教女神Lakshmi（财富女神）、月亮和预期中的装在壶中的神圣甘露（Kumbh）显现了出来。但是……甘露一出来，恶魔们就试图夺取。毗湿奴大神变成迷惑女神莫希尼的形态，欺骗恶魔并将甘露分给所有印度教众神。\n    </paragraph>\n    <paragraph>\n      逃跑时，印度教众神被恶魔追赶并饮用这些甘露时，不朽甘露的滴落在印度不同的地区。这就是庆祝Kumbh的四个地点：Haridwar, Prayag, Nashik, 和Ujjain。因此，这就是Samudra Manthan的故事，体现了‘Kumbh’的含义。\n    </paragraph>\n    <paragraph>\n      从象征意义上讲，Kumbh代表人体，人体内包含着不朽的甘露。只有古代的Rishis和圣人们曾提到过这一点。\n    </paragraph>\n  ',
  'paush-purnima.subtitle': '月神之日。',
  'paush-purnima.hero-image-alt': '满月被云遮住的夜景。',
  'paush-purnima.summary': '纪念月神 Chandra 的一天。',
  'paush-purnima.content':
    '\n    <p>\n      Paush Purnima标志着印度教阴历中的Paush月的满月日。它与月亮有着重要的联系，因此被认为是进行洗礼、更新和全面净化人们身体和内心的吉祥日。\n    </p>\n    <paragraph>\n      这一天也是向月亮神Lord Chandra祈求祝福的最佳日子。信徒们会在这一天进行特定的斋戒。\n    </paragraph>\n  ',
  'mauni-amavasya.subtitle': '玛格的荣耀。',
  'mauni-amavasya.hero-image-alt': '在恒河上轻微日照中划船的个人景象。',
  'mauni-amavasya.summary': '玛格梅拉的主要沐浴日期；在数百万人中，沉默与反思的一天。',
  'mauni-amavasya.content':
    '\n    <p>\n      发生在新月日，这一天被视为玛格梅拉期间沐浴最吉祥的一天。信徒们在这一天遵守\n      Maun Vrat（沉默誓言，其中人们完全不说话[印度的Rishis进一步描述为人们内心世界的完全\n      沉默]），在沉默中反思他们的精神，同时进行被认为能给予他们深刻内在益处的仪式。\n    </p>\n    <paragraph>\n      ‘Mauni’一词直译为‘沉默’。被认为是精神提升旅程的重要部分，需要内心的\n      和平。\n    </paragraph>\n  ',
  'makar-sankranti.subtitle': '季节的变换。',
  'makar-sankranti.hero-image-alt': '阳光明媚的白花田。',
  'makar-sankranti.summary': '印度教历法中最吉祥的日子之一。季节的变换和新的开始。',
  'makar-sankranti.content':
    '\n    <p>\n      这是印度教历中最吉祥的日子之一，当太阳进入摩羯座（Makara）。它象征着冬天的结束和长日的开始。这一天特别有利于向需要帮助的人施舍以获得神圣的祝福，并在圣河恒河中沐浴。\n    </p>\n    <paragraph>\n      Makar Sankranti还被视为重新开始事情的理想时间，为了个人生活的重新发掘和重塑，类似于季节的转变。\n    </paragraph>\n  ',
  'maha-shivratri.subtitle': 'Shiva 的伟大之夜。',
  'maha-shivratri.hero-image-alt': '在蓝天下 Shiva 主的雕像。',
  'maha-shivratri.summary': '献给湿婆神的一天，在摩赫节即将结束之前举行。',
  'maha-shivratri.content':
    '\n    <p>\n      这是献给湿婆神的一天，在摩赫节即将结束之前举行。信徒们斋戒并进行神圣的仪式以尊敬湿婆神。\n      在这一天沐浴被认为是对湿婆神的敬仰，帮助信徒获得解脱和主的祝福，并驱散他们生活中的一切黑暗。\n    </p>\n    <paragraph>\n      在这一天，特定的咒语和颂歌被吟诵和歌唱。\n    </paragraph>\n  ',
  'maghi-purnima.subtitle': '满月之日。',
  'maghi-purnima.hero-image-alt': '身着橙色、身影模糊的年长苦行僧，在蓝天下。',
  'maghi-purnima.summary':
    '与创造神 Brahma 以及在整个 Kumbh 期间住在河边的圣人社区相关的日子。',
  'maghi-purnima.content':
    '\n    <p>\n      这个满月日与印度教的创造之神梵天有关。\n    </p>\n    <paragraph>\n      这一天的沐浴被认为能带来所有神祇的祝福和支持，同时它也与整个Kumbh期间居住在河边的圣人或Kalpvasis有关，他们放弃了所有其他的舒适。\n    </paragraph>\n  ',
  'basant-panchami.subtitle': '春天的开始。',
  'basant-panchami.hero-image-alt':
    '印度知识和艺术的女神 Saraswati。取自 Raja Ravi Varma 的画作。',
  'basant-panchami.summary':
    '庆祝春天的到来，Basant Panchami 是献给印度知识和艺术的女神 Saraswati 的日子。',
  'basant-panchami.content':
    '\n    <p>\n      被庆祝为春天的到来，Basant Panchami是献给知识和艺术的印度教女神Saraswati，信徒们穿着黄色衣服并向萨拉斯瓦蒂女神献上黄色花朵。全印度的教育机构以最虔诚的方式向女神致敬，组织特别的祈祷。\n    </p>\n    <paragraph>\n      在这个吉祥的沐浴日会赐予智慧和知识。\n    </paragraph>\n  ',
  'kumbh-2025.subtitle': '踏上您的摩赫节2026旅程。',
  'kumbh-2025.hero-image-alt': '在造船厂日落时分，恒河上的船只景象。',
  'kumbh-2025.summary': '了解更多关于摩赫节的重要性以及在这个盛大节日期间举行的活动。',
  'camp67-reservation.book-with-us': '与我们一起预订您的旅行',
  'camp67-reservation.timeout.title': '您还有10分钟的时间来确认您的预订。',
  'camp67-reservation.timeout.description':
    '请注意，由于预订需求量大，我们不能再长时间保留您的预订。',
  'camp67-reservation.timeout.ok': '好的',
  'camp67-reservation.form.step-1': '<strong>步骤 1/3：</strong> 选择您的帐篷体验',
  'camp67-reservation.form.step-1.adult': '成人',
  'camp67-reservation.form.step-1.children': '儿童',
  'camp67-reservation.form.step-1.children-detail': '18岁以下',
  'camp67-reservation.form.step-2': '<strong>步骤 2/3：</strong> 选择您的日期',
  'camp67-reservation.form.step-2.tent-option.unavailable':
    '在您选择的日期内，此房间不可用，总客人数。',
  'camp67-reservation.form.step-2.tent-option.image-alt':
    '展示 camp67 下 {{type}} 提供的帐篷体验。',
  'camp67-reservation.form.step-3': '<strong>步骤 3/3:</strong> 输入您的详细信息',
  'camp67-reservation.form.step-3.guests': '客人名单*',
  'camp67-reservation.form.step-3.disclaimer':
    '我们需要所有客人的最低详细信息。查看<payment-policy-link>我们的政策以获取更多信息。</payment-policy-link>',
  'camp67-reservation.form.step-3.additional-bed': '加床',
  'camp67-reservation.form.step-3.guests.enter-name': '输入名字...',
  'camp67-reservation.form.step-3.guests.enter-age': '输入年龄...',
  'camp67-reservation.form.step-3.gender-male': '男',
  'camp67-reservation.form.step-3.gender-female': '女',
  'camp67-reservation.form.step-3.gender-non-binary': '非二元性别',
  'camp67-reservation.form.step-3.gender-none': '无',
  'camp67-reservation.form.step-3.gender-prefer-not-to-say': '不愿透露',
  'camp67-reservation.form.step-3.primary-contact': '主要联系人*',
  'camp67-reservation.form.step-3.primary-contact.inform':
    '选择谁来接收预订更新消息。所有数据均为<privacy-policy-link>安全处理。</privacy-policy-link>',
  'camp67-reservation.form.step-3.primary-contact.select': '选择您的主要联系人',
  'camp67-reservation.form.step-3.primary-contact.email': '输入电子邮件地址...',
  'camp67-reservation.form.step-3.primary-contact.phone': '输入电话号码...',
  'camp67-reservation.form.submit.bathing-added': '已添加沐浴日期。',
  'camp67-reservation.form.submit.bathing-charged': '已收取沐浴日期费用。',
  'camp67-reservation.form.submit.night': '夜',
  'camp67-reservation.form.submit.nights': '夜晚',
  'camp67-reservation.form.submit.room': '房间',
  'camp67-reservation.form.submit.rooms': '房间',
  'camp67-reservation.form.submit.empty': '请先填写您的详细信息和日期。',
  'camp67-reservation.form.submit.total': '总额',
  'camp67-reservation.form.submit.price-shown-in': '显示价格的货币',
  'camp67-reservation.form.submit.exchange-calculated': '汇率每日计算',
  'camp67-reservation.payment': '付款',
  'camp67-reservation.payment.tandc':
    '我同意<terms-of-service-radio>服务条款</terms-of-service-radio>',
  'camp67-reservation.payment.domestic-and-international': '适用于印度&国际客户。',
  'camp67-reservation.payment.international': '适用于国际客户。',
  'camp67-reservation.payment.provider-alt': '支付提供商的标志',
  'camp67-reservation.payment.continue': '继续以确认支付',
  'camp67-contact.contact-us': '联系我们',
  'camp67-contact.offered-by': 'camp67由...提供',
  'camp67-contact.address': '总部地址',
  'camp67-contact.questions': '如果有任何问题或疑虑，请联系我们：',
  'camp67-contact.email': '电子邮件',
  'camp67-contact.phone': '电话',
  'camp67-contact.see-tos': '查看我们的服务条款',
  'camp67-reservation.form.step-1.summary.dates': '您的入住日期',
  'camp67-reservation.form.step-1.summary.guests': '住客',
  'camp67-reservation.form.step-2.summary.rooms': '您选择的房间',
  'camp67-reservation.form.step-2.summary.rooms.empty': '请选择您的房间',
  'camp67-reservation.form.step-3.summary.guests': '您的住客详情',
  'camp67-reservation.form.step-3.summary.guests.empty': '请输入住客详情',
  'camp67-reservation.form.step-3.summary.primary': '主要联系人',
  'camp67-reservation.form.step-3.summary.primary.empty': '请提供主要联系人',
  'camp67-reservation.form.step-1.summary.dates.value': '至',
  'camp67-reservation.form.step.disabled.tooltip': '请先完成上一步。',
  'camp67-reservation.form.step-1.summary.dates.empty-start': '请选择开始日期',
  'camp67-reservation.form.step-1.summary.dates.empty-end': '请选择结束日期',
  'camp67-reservation.form.step-1.summary.guests.empty': '请选择客人人数',
  'camp67-snackbar.invalid-date-range': '您选择的日期范围无效。',
  'camp67-snackbar.invalid-bathing-dates-range': '含浴日期的预订必须至少为3天2晚。',
  'camp67-reservation.form.step-1.next': '前往第 2 步',
  'camp67-reservation.form.step-2.next': '前往第 3 步',
  'camp67-reservation.form.step.next': '下一步',
  'camp67-reservation.form.step-1.next.tooltip.disabled': '请先选择您的房间。',
  'camp67-reservation.form.step-2.summary.rooms.add.tooltip': '添加 1',
  'camp67-reservation.form.step-2.summary.rooms.subtract.tooltip': '减去 1',
  'camp67-reservation.form.step-2.next.tooltip.disabled': '请先填写您的日期。',
  'camp67-reservation.form.step-3.next.tooltip.disabled': '请先提供客人和联系信息。',
  'camp67-reservation.form.step.expand': '展开步骤',
  'camp67-reservation.form.step.collapse': '折叠步骤',
  'camp67-reservation.form.step-1.tent-option.unavailable':
    '该房间在您选择的日期和总客人数不可用。',
  'camp67-reservation.form.step-1.tent-option.image-alt':
    '显示在 camp67 提供的 {{type}} 类型的帐篷体验。',
  'camp67-reservation.form.step-1.room-viewer': '查看房间：',
  'camp67-reservation.form.step-1.room-gallery': '图片 {{current}} / {{total}}',
  'camp67-reservation.form.step-1.summary.rooms': '您选择的房间',
  'camp67-reservation.form.step-1.summary.rooms.add.tooltip': '增加 1',
  'camp67-reservation.form.step-1.summary.rooms.subtract.tooltip': '减少 1',
  'camp67-reservation.form.step-1.summary.rooms.empty': '请选择您的房间',
  'camp67-reservation.form.step-2.adult': '成人',
  'camp67-reservation.form.step-2.children': '儿童',
  'camp67-reservation.form.step-2.children-detail': '18 岁以下',
  'camp67-reservation.form.step-2.summary.dates': '您的住宿日期',
  'camp67-reservation.form.step-2.summary.dates.empty-start': '请选择开始日期',
  'camp67-reservation.form.step-2.summary.dates.empty-end': '请选择结束日期',
  'camp67-reservation.form.step-2.summary.dates.value': '到',
  'camp67-reservation.form.step-2.summary.guests.empty': '请选择客人数',
  'camp67-reservation.form.step-2.summary.guests': '客人',
  'camp67-header.see-prices': '浏览产品',
  'camp67-header.inquiry': '表达兴趣',
  'camp67-snackbar.invalid-bathing-date-selected': '预订不能在沐浴日期开始或结束。',
  'camp67-accommodation.price-bathroom-included': '私人浴室和厕所',
  'camp67-accommodation-and-amenities.private.title': '豪华与私人小屋帐篷住宿',
  'camp67-accommodation-and-amenities.dorm.title': '宿舍帐篷住宿',
  'camp67-tent-amenity.toiletries.private-bathroom': '私人附带厕所和浴室设施',
  'camp67-accommodation.price-shared-bathroom-included': '带浴室和厕所',
  'camp67-reservation.form.step-3.too-many-guests':
    '<strong>⚠️ 宾客过多</strong><br/>请增加更多房间，或将宾客人数减少至 <tentCapacityCode>{{totalTentCapacity}}</tentCapacityCode>。您的房间总共提供 <roomsCapacityCode>{{totalTentCapacity}} 张床</roomsCapacityCode>，但您输入了 <guestsCountCode>{{guestCount}} 位宾客</guestsCountCode>。如有疑问，请联系 <bookingsCode>bookings@camp67.com</bookingsCode>。',
  'camp67-navigation.packages.premium-twin-room': '高级小屋',
  'camp67-navigation.packages.private-group-cottage': '私人团体小屋',
  'camp67-accommodation.premium-twin-room.title': '高级小屋',
  'camp67-accommodation.premium-twin-room.image-alt':
    '一个宽敞的房间，配有两张单人床、行李架、椅子和桌子。',
  'camp67-accommodation.premium-twin-room.subtitle': '适合两人。',
  'camp67-accommodation.premium-twin-room.description':
    '一个带有两张单人床的高级套房。 适合情侣、朋友或兄弟姐妹。',
  'camp67-accommodation.premium-twin-room.guests': '2 位客人',
  'camp67-accommodation.private-group-cottage.title': '私人团体小屋',
  'camp67-accommodation.private-group-cottage.image-alt':
    '一个经济实惠、放松、适合 8 人的单人床宿舍房间',
  'camp67-accommodation.private-group-cottage.subtitle': '适合团体，宿舍风格。',
  'camp67-accommodation.private-group-cottage.description':
    '一个大的私人小屋——有8张单人床和带卫生间和浴室。',
  'camp67-accommodation.private-group-cottage.guests': '8 位客人',
  'camp67-accommodation.price-per-guest-private': '/ 晚',
  'camp67-tent-page.premium-twin-room-summary':
    '<p>\n 高级小屋非常适合情侣、朋友和兄弟姐妹。它是一间舒适、宽敞且豪华的帐篷房间，为您提供完美的住宿体验，当您前往或从日常探索Magh Mela场地回来时。\n</p>\n<paragraph>我们鼓励您手握一杯来自camp67咖啡馆的咖啡，坐下来交谈。与对方讨论当天观察到的事情，并计划接下来的一天！</paragraph>',
  'camp67-tent-page.private-group-cottage-summary':
    '<p>\n作为独行旅客、博主或数字游民想要结识新朋友吗？宿舍\n为你而设。 在典型的旅行旅馆环境中加入他人。 那是\n房间里有八张床，与您作为独行旅客习惯的“给我一些\n空间”和“我想聊天”之间的微妙平衡。\n</p>',
  'camp67-contact.campsite-address': '营地地址',
  'camp67-contact.helpdesk': '帮助台号码',
  'camp67-contact.whatsapp-only': '仅用于 WhatsApp 消息',
  'camp67-contact.outside-india': '来自印度以外',
  'camp67-contact.map': '在地图上查看',
  'camp67-tent-amenity.comfortable-living.side-table-glasses': '带一次性杯子的边桌',
  'camp67-tent-amenity.comfortable-living.side-table': '边桌',
  'camp67-tent-amenity.toiletries.bath-towel-single': '薄棉毛巾 (Gamcha)',
  'camp67-tent-amenity.power-storage.electric-power-point-2x-s': '2个电源插座',
  'camp67-tent-amenity.food-beverage.lemongrass-tea': 'Sukrit Lemongrass Tea',
  'camp67-navigation.kumbh-2025.sacred-gathering-of-magh-mela': '玛格梅拉：神圣的聚会',
  'significance-of-magh.subtitle': '玛格的圣节集会。',
  'significance-of-magh.hero-image-alt': '信徒在玛格梅拉期间在特里维尼桑冈进行神圣沐浴。',
  'significance-of-magh.summary':
    '每年在吉祥的印度教玛格月（1月至2月）举行的玛格梅拉，是在神圣河流岸边的信徒们聚集，进行沐浴、冥想和寻求精神提升的传统时间。',
  'significance-of-magh.content':
    '\n    <p>\n      玛格梅拉，经常被视为更小但同样深刻的“昆布”亲戚，每年在Prayagraj的\n      恒河、亚穆纳河和神秘的萨拉斯瓦蒂河的神圣汇流处庆祝。\n    </p>\n    <paragraph>\n      植根于古老传统中，玛格月被认为是进行精神修行的至高无上的吉祥月份。印度教经典，如\n      《往世书》，强调在这段期间，尤其是在Triveni Sangam沐浴可以洗去罪孽并开启\n      通往解脱（摩克沙）的道路。\n    </paragraph>\n    <paragraph>\n      玛格梅拉不仅仅是沐浴的仪式，而是圣人、贤者、苦行者和世俗人共同的神圣聚会。来自印度各地\n      及海外的人们聚集在一起进行忏悔、节制、诵经并沉浸于信仰中。许多人参加Kalpavas —\n      一个简约誓言，他们整个月都待在河岸边，专心于祈祷、冥想和奉献。\n    </paragraph>\n    <paragraph>\n      集市象征着信仰的永恒传承和宇宙周期的节奏，提醒人们关于有限与无限之间的\n      联合。正如河流在Sangam融合，玛格梅拉代表着追求真理中的身体、心灵和精神的\n      融合。\n    </paragraph>\n    <paragraph>\n      在象征意义上，河流代表了人类意识的通道，它们的汇流象征着知识、信仰和行动的统一，\n      内在人。玛格梅拉因此激励个人净化内心，并以焕然一新的清晰度走上法的道路。\n    </paragraph>\n  ',
  'camp67-inquiry.event-badge': 'Magh Mela 2026 • 1月3日 - 2月18日',
  'camp67-inquiry.hero-subtitle':
    '位于神圣汇流处中心地带，提供配备现代设施的高端帐篷住宿',
  'camp67-inquiry.express-interest': '提交意向',
  'camp67-inquiry.express-your-interest': '提交您的意向',
  'camp67-inquiry.modal-title': '提交您的意向',
  'camp67-inquiry.modal-subtitle': 'Magh Mela 2026 • 1月3日 - 2月18日',
  'camp67-inquiry.accommodation-preference': '住宿偏好',
  'camp67-inquiry.no-preference': '无偏好',
  'camp67-inquiry.twin-cottage': '双床小屋',
  'camp67-inquiry.premium-cottage': '高级小屋',
  'camp67-inquiry.family-cottage': '家庭小屋',
  'camp67-inquiry.private-group': '私人团体小屋',
  'camp67-inquiry.dorm-single': '宿舍单人床位',
  'camp67-inquiry.dorm-bunk': '宿舍上下铺床位',
  'camp67-inquiry.checkin': '入住',
  'camp67-inquiry.checkout': '退房',
  'camp67-inquiry.checkin-date': '入住日期',
  'camp67-inquiry.checkout-date': '退房日期',
  'camp67-inquiry.guests': '住客',
  'camp67-inquiry.number-of-guests': '住客人数',
  'camp67-inquiry.how-many': '多少位？',
  'camp67-inquiry.guest-singular': '位住客',
  'camp67-inquiry.guest-plural': '位住客',
  'camp67-inquiry.guests-10-plus': '10位以上住客',
  'camp67-inquiry.contact-details': '您的联系方式',
  'camp67-inquiry.full-name': '姓名',
  'camp67-inquiry.email': '电子邮箱',
  'camp67-inquiry.phone': '电话号码',
  'camp67-inquiry.your-name': '您的姓名',
  'camp67-inquiry.email-placeholder': 'you@example.com',
  'camp67-inquiry.phone-placeholder': '+91 XXXXX XXXXX',
  'camp67-inquiry.additional-message': '附加留言（可选）',
  'camp67-inquiry.message-placeholder': '有任何特殊需求或问题吗？',
  'camp67-inquiry.required-fields-error': '请填写所有标有 * 的必填项',
  'camp67-inquiry.submit-interest': '提交意向',
  'camp67-inquiry.submitting': '提交中…',
  'camp67-inquiry.thank-you': '谢谢！',
  'camp67-inquiry.success-message':
    '我们已收到您的意向，并将在12小时内与您联系，告知可用情况及下一步安排。',
  'camp67-inquiry.close': '关闭',
  'camp67-inquiry.secure-info': '🔒 您的信息是安全的。',
  'camp67-inquiry.ready-to-experience': '准备好体验 Magh Mela 2026 了吗？',
  'camp67-inquiry.interest-in': '提交意向：',
  'camp67-we-love-kumbh.full-heading':
    '我们了解并<love-highlight>热爱</love-highlight> Kumbh',
  'camp67-reservation.form.step': '步骤',
  'camp67-reservation.form.step.continue': '继续',
  'camp67-reservation.form.step.reset': '重置',
  'camp67-reservation.form.step-1.price-per-night': '/晚',
  'camp67-reservation.form.step-1.meals-included': '含餐食',
  'camp67-reservation.form.step-1.private-bathroom': '独立卫浴',
  'camp67-reservation.form.step-1.shared-bathroom': '共用卫浴',
  'camp67-reservation.form.step-2.check-in': '入住日期',
  'camp67-reservation.form.step-2.check-out': '退房日期',
  'camp67-reservation.form.step-3.guests.enter-gender': '选择性别…',
  'camp67-reservation.form.submit.continue': '继续',
  'camp67-reservation.payment.pay-with': '支付方式',
  'camp67-reservation.payment.disabled': '请先接受服务条款。',
  'camp67-reservation.payment.paypal.title': '在 PayPal 中完成',
  'camp67-reservation.payment.paypal.nearly-there': '马上就好了！',
  'camp67-reservation.payment.paypal.instructions':
    '请在下方的 PayPal 中输入您的信息以完成付款。完成后我们会将您重定向回来。',
  'camp67-reservation.payment.error.title': '出现问题',
  'camp67-reservation.payment.error.description': '我们无法处理您的付款。请重试。',
  'camp67-reservation.payment.error.contact-support': '联系支持',
  'camp67-accommodation.starting-from': '起价',
  'camp67-accommodation.per-night': '每晚',
  'camp67-accommodation.capacity': '容量',
  'camp67-accommodation.guest': '位客人',
  'camp67-accommodation.guests': '位客人',
  'camp67-accommodation.gallery': '图库',
  'camp67-accommodation.about': '关于此住宿',
  'camp67-accommodation.whats-included': '包含内容',
  'camp67-accommodation.ready-cta-title': '准备好体验 Mahakumbh 了吗？',
  'camp67-accommodation.ready-cta-description':
    '立即预订，锁定你在 Magh Mela 2026 的名额。',
};
